<ng-container *transloco="let t; prefix: scope">
  <img src="assets/lundify_logo.png" alt="Lundify Logo" class="absolute top-0 right-6 w-16 h-auto" />
  <div class="p-6">
    <p class="text-blg-grey-600">{{ t('bundleTitle') }}</p>
    <ng-container *ngIf="!isLoading(); else loadingTemplate">
      <p class="mt-4 text-xl font-semibold">{{ bundleName() }}</p>
    </ng-container>
    <bl-frontend-button
      variant="tonal"
      [text]="t('editSubscription')"
      (onclick)="openClientInLundify()"
      [trailingIcon]="{ name: 'arrow-up-right-from-square' }"></bl-frontend-button>
  </div>

  <ng-template #loadingTemplate>
    <p class="animate-pulse h-6 bg-blg-grey-100 rounded w-1/2"></p>
  </ng-template>
</ng-container>
